import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { createBlog } from "../../../../services/operations/blogApi";
import BlogEditorForm from "./BlogEditorForm";

const AddBlog = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const saveBlog = async (payload) => {
    const createdBlog = await createBlog(payload, token);
    if (createdBlog) navigate("/dashboard/blogs");
    return createdBlog;
  };

  return (
    <div className="p-6 text-richblack-5 sm:p-10">
      <h1 className="mb-2 text-3xl font-bold">Create Blog</h1>
      <p className="mb-8 text-richblack-300">
        Write the complete article and add as many supporting images as needed.
      </p>
      <BlogEditorForm
        token={token}
        submitLabel="Publish Blog"
        onSubmit={saveBlog}
      />
    </div>
  );
};

export default AddBlog;
